module.exports = __webpack_public_path__ + "img/button-1.6a10e3c0.png";